'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AspectRatioContent = function AspectRatioContent(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-aspect-ratio-content' },
    children
  );
};

AspectRatioContent.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = AspectRatioContent;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/AspectRatioContent/AspectRatioContent.js
// module id = 519
// module chunks = 11